import { compose } from 'redux';
import hoistStatics from 'hoist-non-react-statics';
import PropTypes from 'prop-types';
import React from 'react';

import { Container } from './styles';
import DashboardSidebar from '../dashboard-sidebar';
import withLayout from '../../../core/components/with-layout';

const withDashboardSidebar = (WrappedComponent) => {
  const WithDashboardSidebar = (props) => {
    const { active } = props;

    return (
      <Container active={active}>
        <DashboardSidebar active={active} />
        <WrappedComponent
          match={props.match}
          history={props.history}
        />
      </Container>
    );
  };

  WithDashboardSidebar.propTypes = {
    active: PropTypes.string.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
    }).isRequired,
  };

  return compose(
    withLayout(),
  )(hoistStatics(WithDashboardSidebar, WrappedComponent));
};

export default withDashboardSidebar;
